(function ($) {
    var root = am5.Root.new("chartdiv");
    const responsive = am5themes_Responsive.newEmpty(root);

    responsive.addRule({
        relevant: function (width, height) {
            return width < 520;
        },
        applying: function () {
            zoomControl.homeButton.set("visible", false);
            zoomControl.plusButton.set("visible", false);
            zoomControl.minusButton.set("visible", false);
        },
        removing: function () {
            zoomControl.homeButton.set("visible", true);
            zoomControl.plusButton.set("visible", true);
            zoomControl.minusButton.set("visible", true);
        }
    });

// Set themes
    root.setThemes([
        am5themes_Animated.new(root),
        responsive
    ]);


    var chart = root.container.children.push(
        am5map.MapChart.new(root, {
            projection: am5map.geoNaturalEarth1(),
            preventDragOut: true,
            panX: "translateX",
            panY: "translateY",
            wheelX: "none",
            wheelY: "none",
            pinchZoom: false,
            wheelSensitivity: 0.6,
            homeZoomLevel: 1.07,
            homeGeoPoint: {
                latitude: 10,
                longitude: 24
            },
            minZoomLevel: .85,
            maxZoomLevel: 7
        })
    );


//Control+scroll
    var overlay = root.container.children.push(am5.Container.new(root, {
        width: am5.p100,
        height: am5.p100,
        layer: 100,
        visible: false
    }));

    var curtain = overlay.children.push(am5.Rectangle.new(root, {
        width: am5.p100,
        height: am5.p100,
        fill: am5.color(0x000000),
        fillOpacity: 0
    }));

    var message = overlay.children.push(am5.Label.new(root, {
        text: "Use CTRL + Scroll to zoom",
        fontSize: 18,
        fill: am5.color('#083266'),
        x: am5.p50,
        y: am5.p100,
        centerX: am5.p50,
        centerY: am5.p100
    }));
    chart.events.on("wheel", function (ev) {
        if (ev.originalEvent.ctrlKey) {
            ev.originalEvent.preventDefault();
            chart.set("wheelY", "zoom");
        } else {
            chart.set("wheelY", "none");
            overlay.show();
            overlay.setTimeout(function () {
                overlay.hide()
            }, 3000);
        }
    });

    var zoomControl = chart.set("zoomControl", am5map.ZoomControl.new(root, {
        x: am5.p0,
        centerX: am5.p0,
        y: am5.p100,
        centerY: am5.p100,
        paddingBottom: 40,
        paddingLeft: 5
    }));
    zoomControl.homeButton.set("visible", true);

    var btnSettings = {
        cornerRadiusTL: 4,
        cornerRadiusTR: 4,
        cornerRadiusBR: 4,
        cornerRadiusBL: 4,
        fill: am5.color('#4D93C5'),
        fillOpacity: 0.4
    };
    var btnSettings_hover = {
        fill: am5.color('#005EA2'),
        fillOpacity: 0.8
    }
    var btnSettings_down = {
        fill: am5.color('#023458'),
        fillOpacity: 1.0
    }

    zoomControl.homeButton.get("background").setAll(btnSettings);
    zoomControl.plusButton.get("background").setAll(btnSettings);
    zoomControl.minusButton.get("background").setAll(btnSettings);

    zoomControl.homeButton.get("background").states.create("hover", {}).setAll(btnSettings_hover);
    zoomControl.plusButton.get("background").states.create("hover", {}).setAll(btnSettings_hover);
    zoomControl.minusButton.get("background").states.create("hover", {}).setAll(btnSettings_hover);

    zoomControl.homeButton.get("background").states.create("down", {}).setAll(btnSettings_down);
    zoomControl.plusButton.get("background").states.create("down", {}).setAll(btnSettings_down);
    zoomControl.minusButton.get("background").states.create("down", {}).setAll(btnSettings_down);

// Create polygon series
    var worldSeries = chart.series.push(am5map.MapPolygonSeries.new(root, {
        geoJSON: am5geodata_worldLow,
        exclude: ["AQ"]
    }));

    worldSeries.mapPolygons.template.setAll({
        fill: am5.color('#d8dbe0'),
        stroke: am5.color("#626874"),
        fillOpacity: .88
    });

    worldSeries.events.on("datavalidated", () => {
        chart.goHome();
    });

    am5.array.each(map_data, function (group) {
        var countries = [];
        am5.array.each(group.data, function (country) {
            countries.push(country.id)
        });
        var polygonSeries = chart.series.push(am5map.MapPolygonSeries.new(root, {
            geoJSON: am5geodata_worldLow,
            include: countries,
            name: group.name,
            fill: am5.color(group.color)
        }));

        polygonSeries.mapPolygons.template.setAll({
            tooltipText: "[bold]{name}[/]\n {type}",
            interactive: true,
            cursorOverStyle: "pointer",
            fill: am5.color(group.color)
        });

        polygonSeries.mapPolygons.template.states.create("hover", {
            fill: am5.Color.brighten(am5.color(group.color), -0.05)
        });

        polygonSeries.mapPolygons.template.events.on("pointerover", function (ev) {
            ev.target.series.mapPolygons.each(function (polygon) {
                polygon.states.applyAnimate("hover");
            });
        });

        polygonSeries.mapPolygons.template.events.on("pointerout", function (ev) {
            ev.target.series.mapPolygons.each(function (polygon) {
                polygon.states.applyAnimate("default");
            });
        });
        polygonSeries.mapPolygons.template.events.on("click", function (ev) {
            var id = '#' + ev.target.dataItem.dataContext.key,
                url = ev.target.dataItem.dataContext.url,
                container = $('.tab-container');

            container.find('.tab-nav .tab-menu li').toggleClass('active', false);
            container.find('.tabs .tab').toggleClass('active', false);
            container.find('.tab-nav .tab-menu li a[href="' + url + '"]').closest('li').toggleClass('active', true);
            container.find(id).toggleClass('active', true);

            history.pushState({id: id}, '', url);

            $('html, body').animate({scrollTop: $(id).offset().top - 160}, 1200, "linear");

        });
        polygonSeries.data.setAll(group.data);
    });

    var pointSeries = chart.series.push(
        am5map.MapPointSeries.new(root, {
            geoJSON: marker_data
        })
    );

    pointSeries.bullets.push(function () {

        var bulletTemplate = am5.Template.new({
            fill: am5.color('#0186B8')
        });

        var circle = am5.Circle.new(root, {
            radius: 6,
            tooltipText: "[bold]{name}[/]\n {type}",
            interactive: true,
            cursorOverStyle: "pointer",
            templateField: "bulletSettings"
        }, bulletTemplate);


        circle.events.on("click", function (ev) {
            var id = '#' + ev.target.dataItem.dataContext.key,
                url = ev.target.dataItem.dataContext.url,
                container = $('.tab-container');

            container.find('.tab-nav .tab-menu li').toggleClass('active', false);
            container.find('.tabs .tab').toggleClass('active', false);
            container.find('.tab-nav .tab-menu li a[href="' + url + '"]').closest('li').toggleClass('active', true);
            container.find(id).toggleClass('active', true);

            history.pushState({id: id}, '', url);
            $('html, body').animate({scrollTop: $(id).offset().top - 160}, 1200, "linear");

        });

        return am5.Bullet.new(root, {
            sprite: circle
        });
    });

})(jQuery);